import { useMemo, useState } from "react";

import { useListDirectives } from "shared/api/directives/hooks";

import { useSuggestionNavigation } from "features/ui/SuggestionMenu/hooks";

import { DIRECTIVE_SUGGESTIONS_LIMIT } from "./DirectiveComposer.constants";
import type { DirectiveComposerSuggestion } from "./DirectiveComposer.types";
import {
  AVAILABLE_IN_FRONTEND_FILTER,
  getDirectiveComposerSuggestions,
} from "./DirectiveComposer.utils";

const useDirectiveComposerSuggestionSource =
  (): DirectiveComposerSuggestion[] => {
    const { data: directives } = useListDirectives({
      filter: AVAILABLE_IN_FRONTEND_FILTER,
      limit: DIRECTIVE_SUGGESTIONS_LIMIT,
      sort: "usageCount:desc",
    });

    return useMemo(
      () => getDirectiveComposerSuggestions(directives ?? []),
      [directives]
    );
  };

export const useDirectiveSlashSuggestions = () => {
  const suggestions = useDirectiveComposerSuggestionSource();
  const [slashQuery, setSlashQuery] = useState<string | null>(null);
  const matchingDirectives = useMemo(
    () =>
      slashQuery == null
        ? []
        : suggestions
            .filter((directive) =>
              directive.name.toLowerCase().startsWith(slashQuery.toLowerCase())
            )
            .slice(0, 8),
    [slashQuery, suggestions]
  );
  const {
    activeIndex: activeSuggestionIndex,
    handleArrowKey,
    setActiveIndex: setActiveSuggestionIndex,
  } = useSuggestionNavigation(
    matchingDirectives.length,
    matchingDirectives.map((directive) => directive.name).join("\0")
  );

  return {
    activeSuggestionIndex,
    handleArrowKey,
    matchingDirectives,
    setActiveSuggestionIndex,
    setSlashQuery,
  };
};
